module.exports = __webpack_public_path__ + "img/giftcard-banner-small.81d73029.jpg";